module.exports = " <div> <h5 @click=\"collapse(typeId, section)\" style=\"cursor: pointer\"> <span :class=\"{ 'fa fa-caret-down': !isCollapsed(typeId, section), 'fa fa-caret-right': isCollapsed(typeId, section) }\"></span> {{ header || section }} </h5> <div :class=\"{ collapse: isCollapsed(typeId, section) }\"> <slot></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollapsableSection.vue
 ** module id = 219
 ** module chunks = 2
 **/